import { useMemo, useRef } from 'react'
import { useForm } from 'react-hook-form'

import { PktButton, PktInputWrapper, PktRadioButton } from '..'

type FormData = {
  radioform: string
  secondValue: string
}

export default function Radio() {
  const radioRef = useRef<HTMLInputElement | null>(null)

  const radioList = [
    {
      id: 'radioGroupInputwrapper1',
      label: 'Radio med inputwrapper 1',
      name: 'radiogroup',
    },
    {
      id: 'radioGroupInputwrapper2',
      label: 'Radio med inputwrapper 2',
      name: 'radiogroup',
    },
    {
      id: 'radioGroupInputwrapper3',
      label: 'Radio med inputwrapper 3',
      name: 'radiogroup',
    },
  ]

  const radioList2 = [
    {
      id: 'radioGroupInputwrapperError1',
      label: 'Radio med inputwrapper 1',
      name: 'radiogroup2',
    },
    {
      id: 'radioGroupInputwrapperError2',
      label: 'Radio med inputwrapper 2',
      name: 'radiogroup2',
    },
    {
      id: 'radioGroupInputwrapperError3',
      label: 'Radio med inputwrapper 3',
      name: 'radiogroup2',
    },
  ]

  const radioForm = [
    {
      id: 'radioformInputwrapper4',
      label: 'Radio4 med inputwrapper',
      name: 'radioform',
    },
    {
      id: 'radioformInputwrapper5',
      label: 'Radio5 med inputwrapper',
      name: 'radioform',
    },
    {
      id: 'radioformInputwrapper6',
      label: 'Radio6 med inputwrapper',
      name: 'radioform',
    },
  ]

  const handleRadioChange = (id: string, label: string, checked: boolean) => {
    console.log(`Radio with id ${id} and label "${label}" checked:`, checked)
  }

  const { handleSubmit, register, getValues } = useForm<FormData>({
    defaultValues: {
      radioform: 'value1',
      secondValue: 'Second value',
    },
  })

  const MOCK_SUBMIT = useMemo(() => {
    return () => {
      const values = getValues()
      alert('Submitting ' + JSON.stringify(values))
    }
  }, [getValues])

  return (
    <>
      <main className="page-main pkt-container">
        <h1>Radio</h1>

        <section className="component">
          <h2>Med inputwrapper og defaultChecked</h2>
          <form>
            <PktInputWrapper
              label="Etikett"
              helptext="Dette er tekst over avmerkingsboksene."
              optionalTag
              optionalText="Valgfritt"
              forId="radioGroup3"
              hasFieldset
            >
              {radioList.map((radio) => (
                <PktRadioButton
                  key={radio.id}
                  name="radio.group-1"
                  id={radio.id}
                  label={radio.label}
                  defaultChecked={radio.id === 'radioGroupInputwrapper3'}
                  checkHelptext="Denne valgfrie teksten kan brukes til å beskrive etiketten mer
                            detaljert."
                  onChange={(event) => console.log(event.target.id, event.target.checked)}
                  ref={radioRef}
                />
              ))}
            </PktInputWrapper>
          </form>
        </section>

        <section className="component">
          <h2>Med inputwrapper, Tile og error håndtering</h2>
          <p>
            Her viser vi standard versjonen med Tile, og hvordan den ser ut med error. 'hasTile' må settes per
            radiobutton.
          </p>
          <PktInputWrapper
            label="Etikett"
            helptext="Dette er tekst over radiobutton"
            helptextDropdown="Bruk dette tekstfeltet til å skrive mer informasjon om inputfeltet."
            helptextDropdownButton="Les mer"
            optionalTag
            optionalText="Valgfritt"
            forId="radioGroupInput3"
            hasFieldset
            hasError
            errorMessage="Dette er en feilmelding"
          >
            {radioList2.map((radio) => (
              <PktRadioButton
                key={radio.id}
                id={radio.id}
                label={radio.label}
                name={radio.name + '2'}
                checked={radio.id === 'radioGroupInputwrapperError2'}
                checkHelptext="Denne valgfrie teksten kan brukes til å beskrive etiketten mer
                            detaljert."
                onChange={(event) => handleRadioChange('radioError', `${radio.label} med error`, event.target.checked)}
                ref={radioRef}
                hasTile
                hasError
              />
            ))}
          </PktInputWrapper>
        </section>

        <section className="component">
          <h2>hasFieldset vs vanlig</h2>
          <h3>Tester spacing i input-wrapper for å se at det er konsekvent når vi bruker hasFieldset</h3>
          <div className="pkt-grid pkt-grid--full">
            <div className="pkt-cell pkt-cell--span6">
              <PktInputWrapper
                label="Etikett"
                helptext="Dette er tekst over avmerkingsboksene."
                helptextDropdown="Bruk dette tekstfeltet til å skrive mer informasjon om inputfeltet."
                optionalTag
                optionalText="Valgfritt"
                forId="radioGroup2"
              >
                Dette er innhold i inputwrapper uten fieldset
              </PktInputWrapper>
            </div>
            <div className="pkt-cell pkt-cell--span6">
              <PktInputWrapper
                label="Etikett"
                helptext="Dette er tekst over avmerkingsboksene."
                helptextDropdown="Bruk dette tekstfeltet til å skrive mer informasjon om inputfeltet."
                optionalTag
                optionalText="Valgfritt"
                forId="radioGroup2"
                hasFieldset
              >
                Dette er innhold i inputwrapper uten fieldset
              </PktInputWrapper>
            </div>
          </div>
        </section>

        <section className="component">
          <h2>Test av reell skjemaintegrasjon</h2>
          <form onSubmit={handleSubmit(MOCK_SUBMIT)}>
            <PktInputWrapper
              label="Etikett"
              optionalTag
              optionalText="Valgfritt"
              forId="radioGroupForm"
              hasFieldset
              role="radiogroup"
            >
              {radioForm.map((radio, index) => (
                <PktRadioButton
                  key={radio.id}
                  id={radio.id}
                  label={radio.label}
                  value={'value' + index}
                  checkHelptext="Denne valgfrie teksten kan brukes til å beskrive etiketten mer detaljert."
                  {...register('radioform')}
                />
              ))}
            </PktInputWrapper>
            <br />
            <PktButton type="submit">Submit</PktButton>
          </form>
        </section>

        <section className="component">
          <h2>Test med requiredTag, optionalTag og tagText</h2>
          <PktInputWrapper
            label="Etikett"
            optionalTag
            optionalText="Valgfritt"
            forId="radioGroupForm"
            hasFieldset
            role="radiogroup"
          >
            <PktRadioButton
              id="radioTagTest1"
              label="Radio med requiredTag"
              name="radioTagTest"
              requiredTag
              requiredText="Må fylles ut"
              tagText="Taggtekst"
              onChange={(event) => handleRadioChange('radioTagTest1', 'Radio med requiredTag', event.target.checked)}
            />
            <PktRadioButton
              id="radioTagTest2"
              label="Radio med optionalTag"
              name="radioTagTest"
              optionalTag
              optionalText="Valgfritt"
              tagText="Taggtekst"
              onChange={(event) => handleRadioChange('radioTagTest2', 'Radio med optionalTag', event.target.checked)}
            />
            <PktRadioButton
              id="radioTagTest3"
              label="Radio med tagText"
              name="radioTagTest"
              tagText="Taggtekst"
              onChange={(event) => handleRadioChange('radioTagTest3', 'Radio med tagText', event.target.checked)}
            />
          </PktInputWrapper>
        </section>
      </main>
    </>
  )
}
